<div class="container">
  <div class="row">
    <div class="col-12">
      <h2 class="text-center mb-5">Create account</h2>
      <app-registration-withpin-form (submitEvent)="registration($event)"></app-registration-withpin-form>
    </div>
  </div>
</div>

